import { useCallback, useEffect, useState } from "react";
import {
  alertConfig, systemAlerts, systemCode, systemCompanies, systemCrons, systemGeo, systemIntegrations,
  systemNotifyHealth, systemPerformance, systemRevocations, systemSessions, systemStorage, systemTrends,
} from "../../../api/platform";

const LOADERS = {
  code: systemCode,
  performance: systemPerformance,
  trends: systemTrends,
  storage: systemStorage,
  sessions: systemSessions,
  revocations: systemRevocations,
  crons: systemCrons,
  notifyHealth: systemNotifyHealth,
  alerts: systemAlerts,
  thresholds: alertConfig,
  companies: systemCompanies,
  geo: systemGeo,
  integrations: systemIntegrations,
};

// يحمّل نداءات القسم المفتوح فقط بدل 12 نداءً في كل مرة.
export const useSystemData = (keys) => {
  const signature = keys.join(",");
  const [data, setData] = useState({});
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    const list = signature.split(",").filter((key) => LOADERS[key]);
    setBusy(true);
    try {
      const results = await Promise.all(list.map((key) => LOADERS[key]().catch(() => null)));
      setData((prev) => ({ ...prev, ...Object.fromEntries(list.map((key, i) => [key, results[i]])) }));
    } finally {
      setBusy(false);
    }
  }, [signature]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, busy, load };
};
